import React, { useEffect, useState } from 'react'
import { Config } from '@chegg-wt/core/config'

interface BackgroundProp {
  backgroundIFrameUrl?: string
}

const BackgroundIFrame: React.FC<BackgroundProp> = ({ backgroundIFrameUrl }) => {
  const [timestamp, setTimestamp] = useState(0)

  useEffect(() => {
    if (!timestamp) setTimestamp(Date.now())
  }, [])

  const iframeSrc =
    backgroundIFrameUrl ||
    `${Config.gamUrl}${Config.dfpSiteId}/${Config.loginAdUnit}&sz=1440x1024&c=${timestamp}`
  const css: any = {
    width: '100%',
    minHeight: '100%',
    position: 'fixed',
    marginTop: '-16px',
  }
  return !!timestamp && <iframe title="background-gam" src={iframeSrc} style={css} />
}

export default BackgroundIFrame
